





















import { Component, Vue } from "vue-property-decorator";
import DataSource from "devextreme/data/data_source";
import dxCustomStore from "devextreme/data/custom_store";
import projectMeasuringStateOverview from "../services/projectMeasuringStateOverview";
import Card from "@/components/default/Card.vue";
import projectstatussesRepository from "@/services/projects/projectstatussesRepository";
import { DxDataGrid } from 'devextreme-vue';
import { DxColumn, DxEditing, DxPaging, DxLookup } from 'devextreme-vue/data-grid';
import Datagrid from "@/components/default/Datagrid.vue";
import { ProjectsClient, GetAllProjectContactsQuery, DataSourceLoadOptionsBase } from '@/data/web-api-client';
import { LoadOptions } from 'devextreme/data/load_options';
import ProjectProgressionDialog from '../components/ProjectProgressionDialog.vue';

@Component({
  components: {
    Card,
    Datagrid,
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxPaging,
    DxLookup,
    ProjectProgressionDialog
  },
})
export default class ProjectMeasuringStateOverview extends Vue {
  loading: boolean = false;

  private statusOptions: any[] = [];
  private selectedStatusId = -1;
  private selectedwork = '';
  private selectedSubcontractorId = '';

  private projectsClient = new ProjectsClient(undefined, this.$axios);

  public async mounted() {
    this.loadStatusOptions();
  }

  public async loadStatusOptions() {
    try {
      this.loading = true;
      this.statusOptions = (await projectstatussesRepository.get()).data;
    } catch {
      // Do nothing
    } finally {
      this.loading = false;
    }
  }

  public refreshTable() {
    (
      this.$refs.grid as any
    ).$refs.ProjectMeasuringStateOverview.instance.refresh();
  }

  public rowClick(event: any) {
    if (event.rowType === 'group') {
      return;
    }

    const routeData = this.$router.resolve({
      path: `/projects/${event.data.projectId}`,
    });

    window.open(routeData.href, "_blank");
  }

  private showProjectProgression(projectId: string) {
    if (!projectId) {
      return;
    }

    this.projectProgressionDialog.projectId = projectId;
    this.projectProgressionDialog.show = true;
    this.projectProgressionDialog.load();
  }

  private createBox(color: 'red' | 'green' | 'blue' | 'yellow', iconName: string, percentage: number | null | undefined): JQuery<HTMLDivElement> {
    const box = $(document.createElement('div'));

    box.addClass('progression');

    const innerBox = $(document.createElement('div'));

    innerBox.css('background-color', `var(--${color})`);

    innerBox.addClass('progression-box');

    const icon = $(document.createElement('i'));

    icon.addClass(['fas', `fa-${iconName}`]);

    const span = $(document.createElement('span'));

    span.text((percentage ?? 0) + '%');

    innerBox.append(icon);
    innerBox.append(span);

    box.append(innerBox);

    return box;
  }

  get toolbarOptions() {
    return [
      {
        location: "before",
        widget: "dxLookup",
        options: {
          dataSource: this.statusOptions,
          displayExpr: "name",
          valueExpr: "value",
          searchEnabled: true,
          showClearButton: true,
          width: 300,
          onValueChanged: (e: any) => {
            if (e && e.value) {
              this.selectedStatusId = e.value;
            } else {
              this.selectedStatusId = -1;
            }

            this.refreshTable();
          },
          placeholder: "Filter op status",
        },
      },
      {
        location: "before",
        widget: "dxLookup",
        options: {
          dataSource: this.worktypesOptions,
          displayExpr: "text",
          valueExpr: "value",
          searchEnabled: true,
          showClearButton: true,
          width: 300,
          onValueChanged: (e: any) => {
            if (e && e.value) {
              this.selectedwork = e.value;
            } else {
              this.selectedwork = "";
            }

            this.refreshTable();
          },
          placeholder: "Soort werk",
        },
      },
      {
        location: "before",
        widget: "dxLookup",
        options: this.subcontractorsOptions,
      },
    ];
  }

  get columns() {
    const self = this;
    return [
      {
        dataField: "projectNumber",
        caption: "Project nummer",
        groupIndex: 0,
        groupCellTemplate: (cellElement: any, cellInfo: any) => {
          const titleDiv = $(document.createElement('div'));

          // items array property is different for open and closed rows
          const items = cellInfo.data.collapsedItems ?? cellInfo.data.items;

          titleDiv.text(`${cellInfo.value} - ${items[0].projectName}`);
          titleDiv.addClass('title-div');

          const el = $(cellElement);

          el.addClass('group-row');

          const innerDiv = $(document.createElement('div'));

          innerDiv.addClass('inner-div');

          const boxContainer = $(document.createElement('div'));

          boxContainer.addClass('box-container');

          const detailsBtnContainer = $(document.createElement('div'));

          detailsBtnContainer.addClass('btn-container');

          const progressDetailsBtn = $(document.createElement('button'));

          progressDetailsBtn.addClass(['btn', 'btn-primary', 'btn-progress-details']);
          progressDetailsBtn.text('Details');
          progressDetailsBtn.on('click', (e) => {
            e.stopPropagation();
            e.preventDefault();

            this.showProjectProgression(items[0].projectId);
          });

          detailsBtnContainer.append(progressDetailsBtn);

          const projectProgressionBox = this.createBox('green', 'briefcase', items[0].projectProgression);
          const customerInvoicingBox = this.createBox('blue', 'user', items[0].invoicedToCustomerRateExcl);
          const customerPaidBox = this.createBox('red', 'euro-sign', items[0].paidInvoiceRate);
          const subcontractorInvoicingBox = this.createBox('yellow', 'hard-hat', items[0].subcontractorRate);

          boxContainer.append(projectProgressionBox, customerInvoicingBox, customerPaidBox, subcontractorInvoicingBox);

          el.height(50);
          innerDiv.height(50);
          innerDiv.append(titleDiv);
          innerDiv.append(boxContainer);
          innerDiv.append(detailsBtnContainer);
          el.append(innerDiv);
        }
      },
      {
        dataField: "projectName",
        caption: "Project naam"
      },
      {
        dataField: "status",
        caption: "Status",
        dataType: "number",
        lookup: {
          dataSource: self.statusOptions,
          displayExpr: "name",
          valueExpr: "value",
        },
      },
      {
        dataField: "lastVisit",
        caption: "Laatste bezoek",
      },
      {
        dataField: "measuringStateProgress",
        caption: "% vordering meetstaat",
        dataType: "string",
      },
      // {
      //   dataField: "timeProgress",
      //   caption: "% vordering tijd",
      //   dataType: "string",
      // },
      // {
      //   dataField: "onScheme",
      //   caption: "Meetstaat vs. planning",
      //   dataType: "string",
      //   allowEditing: false,
      //   cellTemplate: (cellElement: any, cellInfo: any) => {
      //     var button = $(document.createElement("button"));
      //     $(button).addClass("btn");
      //     if (cellInfo.data.onScheme == true) {
      //       $(button).css("background-color", "#def6eb");
      //       $(button).text("Op schema");
      //     } else {
      //       $(button).css("background-color", "#f0d9d8");
      //       $(button).text("Niet op schema");
      //     }
      //     $(button).css("color", "black");
      //     $(button).css("cursor", "default");
      //     $(cellElement).append(button);
      //   },
      // },
    ];
  }

  get dataSource() {
    return new DataSource({
      store: new dxCustomStore({
        key: "projectId",
        load: async (loadOptions) => {
          const result = await projectMeasuringStateOverview.lookup(
            loadOptions,
            this.selectedStatusId,
            this.selectedwork,
            this.selectedSubcontractorId
          );

          return {
            data: result.data.data,
            totalCount: result.data.totalCount,
          };
        },
      }),
      paginate: true,
    });
  }

  get groupingConfig() {
    return {
      autoExpandAll: false,
      expandMode: 'rowClick'
    }
  }

  get worktypesOptions() {
    const catalog = this.$store.getters["catalogs/list"](
      "WorkTypes"
    ) as ICatalogList;
    var list = [];
    for (var i = 0; i < catalog.values.length; i++) {
      list.push({ value: catalog.values[i], text: catalog.values[i] });
    }
    return list;
  }

  get subcontractorsOptions() {
    return {
      dataSource: {
        key: 'id',
        paginate: true,
        pageSize: 20,
        load: async (loadOptions: LoadOptions) => {
          if (loadOptions.filter) {
            loadOptions.filter = undefined;
          }

          if (loadOptions.searchExpr && loadOptions.searchOperation && loadOptions.searchValue) {
            loadOptions.filter = [['displayName', loadOptions.searchOperation, loadOptions.searchValue],
              'or',
            ['email', loadOptions.searchOperation, loadOptions.searchValue]];
          }

          const options = new DataSourceLoadOptionsBase(Object.assign({}, loadOptions, {
            stringToLower: true,
          }));

          const command = new GetAllProjectContactsQuery({
            projectId: undefined,
            options,
            onlySubcontractors: true
          });

          const result = await this.projectsClient.getAllProjectContacts(command);

          return {
            data: result.data,
          }
        },
        byKey: (val: any) => {
          return val;
        }
      },
      displayExpr: 'displayName',
      valueExpr: 'id',
      searchEnabled: true,
      showClearButton: true,
      width: 300,
      onValueChanged: (e: any) => {
        if (e && e.value) {
          this.selectedSubcontractorId = e.value;
        } else {
          this.selectedSubcontractorId = '';
        }

        this.refreshTable();
      },
      placeholder: "Filter op onderaannemer",
    };
  }

  get projectProgressionDialog() {
    return this.$refs?.projectProgressionDialog as ProjectProgressionDialog;
  }
}
